import { useSelector } from 'react-redux';

export const useRole = roleId => {
    const roles = useSelector(state => state.user.roles) || [];
    return Boolean(roles.find(role => role.roleID === roleId));
};
